import { render, staticRenderFns } from "./selectAdminCommunity.vue?vue&type=template&id=74682260&scoped=true"
import script from "./selectAdminCommunity.vue?vue&type=script&lang=js"
export * from "./selectAdminCommunity.vue?vue&type=script&lang=js"
import style0 from "./selectAdminCommunity.vue?vue&type=style&index=0&id=74682260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74682260",
  null
  
)

export default component.exports